<template>
    <section class="bg-white py-20 lg:py-28" :id="id">
        <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
            <div class="mx-auto max-w-[640px] text-center">
                <h2 class="text-4xl font-black leading-[1.05] tracking-[-0.02em] text-text-main sm:text-5xl">{{ t('process.title') }}</h2>
                <p class="mt-4 text-lg text-text-muted">{{ t('process.subtitle') }}</p>
            </div>

            <ol class="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
                <!-- connecting line on desktop -->
                <div class="pointer-events-none absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent md:block" aria-hidden="true"></div>

                <li v-for="(step, i) in steps" :key="step.title" class="relative flex flex-col items-center text-center md:items-start md:text-left">
                    <span class="relative z-10 flex h-14 w-14 items-center justify-center rounded-2xl bg-text-main text-2xl font-black text-primary ring-8 ring-white">
                        {{ i + 1 }}
                    </span>
                    <h3 class="mt-6 text-xl font-bold text-text-main">{{ t(step.title) }}</h3>
                    <p class="mt-2 max-w-[320px] text-text-muted">{{ t(step.text) }}</p>
                </li>
            </ol>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineProps<{ id?: string }>();

const { t } = useI18n();

const steps = [
    { title: 'process.s1_title', text: 'process.s1_text' },
    { title: 'process.s2_title', text: 'process.s2_text' },
    { title: 'process.s3_title', text: 'process.s3_text' },
];
</script>
